import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: null, message: '' }); // {type: 'success'|'error'|null}

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    // La tua EmailJS Public Key
    const PUBLIC_KEY = "gDwh8PdMs8PPZ2eKs";
    if (!PUBLIC_KEY) {
      console.warn('Missing REACT_APP_EMAILJS_PUBLIC_KEY in your .env file.');
    }

    setLoading(true);
    setStatus({ type: null, message: '' });

    // Campi richiesti dal template:
    // {{name}}, {{email}}, {{phone}}, {{subject}}, {{message}}
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
    };

    try {
      await emailjs.send(
        'service_nga7grn',
        'template_x77u7xa',
        templateParams,
        { publicKey: PUBLIC_KEY }
      );

      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });

      setStatus({
        type: 'success',
        message: 'Messaggio inviato correttamente. Ti risponderò al più presto!'
      });
    } catch (err) {
      console.error('EmailJS error:', err);
      setStatus({
        type: 'error',
        message: 'Si è verificato un errore durante l’invio. Riprova più tardi.'
      });
    } finally {
      setLoading(false);
    }
  };

  // Stile pillola inline (fallback in caso non esistano classi tema)
  const pillStyle = (type) => ({
    textAlign: 'center',
    width: '100%',
    display: 'inline-block',
    marginTop: 16,
    padding: '10px 14px',
    borderRadius: 999,
    fontSize: 14,
    lineHeight: 1.3,
    border: '1px solid',
    background: type === 'success' ? '#e8f5ee' : '#fdecea',
    borderColor: type === 'success' ? '#a6d8b8' : '#f5c6cb',
    color: type === 'success' ? '#1b5e20' : '#7b1116'
  });

  return (
    <section className="st-shape-wrap" id="contact">
      <div className="st-shape1">
        <img src="shape/contact-shape1.svg" alt="shape1" />
      </div>
      <div className="st-shape2">
        <img src="shape/contact-shape2.svg" alt="shape2" />
      </div>
      <div className="st-height-b120 st-height-lg-b80" />
      <SectionHeading
        title="Resta in contatto"
        subTitle="Sono qui per rispondere a ogni tua esigenza: scrivimi o chiamami per fissare un appuntamento o per qualsiasi informazione."
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            {/* puoi usarlo se vuoi iniettare messaggi pre-form */}
            <div id="st-alert" />
            <form
              onSubmit={onSubmit}
              className="row st-contact-form st-type1"
              method="post"
              id="contact-form"
            >
              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Nome</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Inserire nome per intero..."
                    required
                    onChange={handleInputChange}
                    value={formData.name}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Es: esempio@gmail.com"
                    required
                    onChange={handleInputChange}
                    value={formData.email}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Oggetto</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="Per cosa mi scrivi?"
                    required
                    onChange={handleInputChange}
                    value={formData.subject}
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="st-form-field st-style1">
                  <label>Telefono</label>
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder="Es: +39 333 222 1111"
                    required
                    onChange={handleInputChange}
                    value={formData.phone}
                  />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="st-form-field st-style1">
                  <label>Messaggio</label>
                  <textarea
                    cols={30}
                    rows={10}
                    id="message"
                    name="message"
                    placeholder="Scrivi qui il tuo messaggio e richiedi informazioni per ogni tua perplessit&agrave;..."
                    required
                    onChange={handleInputChange}
                    value={formData.message}
                  />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="text-center">
                  <div className="st-height-b10 st-height-lg-b10" />
                  <button
                    className="st-btn st-style1 st-color1 st-size-medium"
                    type="submit"
                    id="submit"
                    name="submit"
                    disabled={loading}
                  >
                    {loading ? 'Invio in corso...' : 'Invia un messaggio'}
                  </button>
                </div>
              </div>
            </form>

            {/* Pillola di stato SOTTO al form */}
            {status.type && (
              <div
                role="status"
                aria-live="polite"
                style={pillStyle(status.type)}
              >
                {status.message}
              </div>
            )}
          </div>
          {/* .col */}
        </div>
      </div>
      <div className="st-height-b120 st-height-lg-b80" />
    </section>
  );
};

export default Contact;
